import React, { useCallback } from 'react';

import { Button, Form, Image, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';

import original from '../../../assets/original.png';
import { setHideInstallButton } from '../../../redux/actions/user/user.actions';
import {
  downloadFromUrl,
  logDebug,
} from '../../../shared/config/globalFunctions';
import { LatestGIMmanagerversionSelector } from '@/redux/selectors/desktopApp.selector';

/**
 *
 * @returns
 */
const InstallGimManagerModal = ({
  t,
  appContext,
  setAppContext,
  hide,
  show,
  ...props
}) => {
  const dispatch = useDispatch();

  const latestVersion = useSelector(LatestGIMmanagerversionSelector);
  console.trace('found version (in modal)', latestVersion);

  const getDownloadDetails = useCallback(() => {
    const version = latestVersion;
    const fileName = version ? `GIMmanager ${version}.exe` : 'GIMmanager.exe';
    console.log('will download ', fileName);
    const url = `${import.meta.env.VITE_DOMAIN}${fileName}`;
    return { url, fileName };
  }, [latestVersion]);

  const handleClick = useCallback(() => {
    const { url, fileName } = getDownloadDetails();
    downloadFromUrl(url, fileName);

    // hide model and hide button from the header.
    setTimeout(() => {
      dispatch(setHideInstallButton(true));
      hide();
      props.onHide();
    }, 1500);

    // Start interval to check GIMmanager is connected or not after 3 minutes.
    setTimeout(
      () => {
        setAppContext({
          ...appContext,
          startedToConnectGIMmanager: true,
          connectionCount: 0,
        });
      },
      3 * 60 * 1000
    );

    //Show button on the header after 6 minutes after click on install button.
    setTimeout(
      () => {
        dispatch(setHideInstallButton(false));
      },
      6 * 60 * 1000
    );
  }, [appContext, dispatch, getDownloadDetails, props, setAppContext]);

  return (
    <Modal
      // {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="managerModal"
      onHide={() => {
        logDebug('trying to hide');
        hide();
      }}
      show={show}
    >
      <Modal.Header closeButton>
        <Modal.Title className="title" id="contained-modal-title-vcenter">
          {t('Header.installGimmanager')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row w-full align-items-center">
          <div
            className="col-md-10 order-2 order-md-1"
            style={{ paddingRight: 0 }}
          >
            <p style={{ marginTop: '1rem' }}>
              {t('Header.GIMmanagerPopupSection1')}
            </p>
            <p>
              {t('Header.GIMmanagerPopupSection2')}{' '}
              <Link to="/faqs" target="_blank">
                {t('Header.needToKnowMoreOnThis')}
              </Link>
            </p>
          </div>
          <div className="col-md-2 order-md-2 order-1" style={{ padding: 0 }}>
            <Image
              className="d-block mx-auto img-fluid logo-size"
              src={original}
            />
          </div>
        </div>
      </Modal.Body>
      <Form>
        <Button
          className="download-button"
          variant="dark"
          onClick={() => handleClick()}
        >
          {t('Header.installForWindows')}
        </Button>
      </Form>
    </Modal>
  );
};

export default InstallGimManagerModal;
